import { render, staticRenderFns } from "./RolodexEntry.vue?vue&type=template&id=1de62b1e&scoped=true&"
import script from "./RolodexEntry.vue?vue&type=script&lang=ts&"
export * from "./RolodexEntry.vue?vue&type=script&lang=ts&"
import style0 from "./RolodexEntry.vue?vue&type=style&index=0&id=1de62b1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de62b1e",
  null
  
)

export default component.exports